import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { HashLink } from 'react-router-hash-link';
import { useRegisterFocus } from '../../../FocusZone';
export const InternalLink = ({ id, className, style, to, hash, onClick, onMouseEnter, onMouseLeave, children, }) => {
    const ref = useRef(null);
    useRegisterFocus(ref);
    return (_jsx(HashLink, Object.assign({ id: id, ref: ref, className: className, style: style, to: `${to}${hash === undefined ? '' : hash}`, rel: "noreferrer noopener", onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: children }), void 0));
};
//# sourceMappingURL=InternalLink.js.map